import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { CartSummaryLine } from '@/components/modules/_shared/CartSummary/types/CartSummaryLine';
import { Font } from '@/components/shared/components/Font';

interface CartSummaryLinesProps {
  lines: CartSummaryLine[];
  strikethrough?: boolean;
}

export const CartSummaryLines = ({ lines, strikethrough }: CartSummaryLinesProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gridGap={4}>
      {lines?.map((line, key) => (
        <Box display={'flex'} justifyContent={'space-between'} key={key}>
          <Font className="overflow-text-ellipsis pr-3" variant={'body2'} strikethrough={strikethrough}>
            {line.units}
            {' x '}
            {line.description}
          </Font>
          <Font variant={'body2'} strikethrough={strikethrough}>
            {formatMoney(line.totalPrice, 2)}
          </Font>
        </Box>
      ))}
    </Box>
  );
};
